import api from 'services/api';

export async function sendResetPassEmail(email: string) {
  const response = await api.post('api/auth/password', {
    user: { email },
  });

  return response;
}
